import React, { useEffect } from "react";
import { Col, Form, Row, Button, ButtonGroup } from "react-bootstrap";
import { MdOutlineSpeakerNotes } from "react-icons/md";
import { useForms } from "../../use-forms/index"
import { z } from "zod"
import { useDispatch } from 'react-redux';
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { getPostalCode } from "../../../../store/register/provider/actions"

const formSchema = z.object({
  zipcode: z.string()
    .nonempty("CEP é obrigatório.")
    .regex(/^\d{5}\d{3}/i, "Apenas números são permitidos"),
  address_number: z.string()
    .nonempty("Número do endereço é obrigatório.")
    .regex(/^[0-9]+$/i, "Apenas números são permitidos"),
  address: z.string("É permitido somente texto.").nonempty("Adress é obrigatório."),
  address_complements: z.string("É permitido somente texto.").optional().default(''),
  address_neighbour: z.string('É permitido somente texto.').nonempty("Address neighbour é obrigatório."),
  address_city: z.string().nonempty("Cidade é obrigatório."),
  country: z.string().nonempty("País é obrigatório."),
  state: z.string().nonempty("Estado é obrigatório."),
  // latitude: z.number(),
  // longitude:z.number()
})

//Form step 1
function Index(props) {
  const dispatch = useDispatch();

  const {
    register,
    setValue,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForms({ validator: formSchema })

  const setFormFromProps = () => {
    const { address_city, address_neighbour, uf, address, country, latitude, longitude} = props;
    setValue('address', address)
    setValue('address_neighbour', address_neighbour)
    setValue('address_city', address_city)
    setValue('state', uf)
    setValue('country', country)
    setValue('country', 'Brasil')
    setValue('latitude', latitude)
    setValue('longitude', longitude)
  }

  setFormFromProps()

  useEffect(() => {
    clearErrors()
    setValue('zipcode', props.form.zipcode)
    setValue('address_number', props.form.address_number)
    setValue('address', props.form.address)
    setValue('address_complements', props.form.address_complements || '')
    setValue('address_neighbour', props.form.address_neighbour)
    setValue('address_city', props.form.address_city)
    setValue('country', props.form.country)
    setValue('latitude', props.form.latitude || 1)
    setValue('longitude', props.form.longitude || 1)
    if(!!props.form.state){setValue('state', props.form.state)}
  }, [])

  const onSubmitForm = data => {
    //post or validate data to/on api endpoint here
    //on success  
    props?.submit(data)
  }

  const onChangeZipcode = (e)=>{
    let zipcode = e.target.value
    if(e.target.value.length >= 8){
     dispatch(getPostalCode({ zipcode }))
    }
    
    if(zipcode.length > 9){
      setValue('address', '')
      setValue('address_neighbour', '')
      setValue('address_city', '')
      setValue('country', '')
      e.target.value = e.target.value.split('',9)
    }
  }

  return (
    <Form onSubmit={handleSubmit(onSubmitForm)} className="col-12 col-md-5 col-lg-4">
      <div className="background"></div>
      <h2 className="mb-2"><MdOutlineSpeakerNotes /> Endereço</h2>
      <p>Preencha os campos correspondentes ao seu endereço, e salve para continuar.</p>
      <Row>
        <Col sm="4">
          <Form.Group className="mb-2" controlId="formPlaintext">
            <Form.Label column sm="5">
              CEP
            </Form.Label>
            <div>
              <Form.Control type="text" {...register('zipcode')}   onBlur={(e) => {onChangeZipcode(e)}} minLength={8} maxLength={9}/>
              {errors.zipcode?.message && <div className="text-danger">{errors.zipcode?.message}</div>}
            </div>
          </Form.Group>
        </Col>

        <Col sm="8">
        </Col>

        <Col sm="12">
          <Form.Group className="mb-2" controlId="formPlaintext">
            <Form.Label column sm="5">
              Endereço
            </Form.Label>
            <div>
              <Form.Control type="text" {...register('address')} />
              {errors.address?.message && <div className="text-danger">{errors.address?.message}</div>}
            </div>
          </Form.Group>
        </Col>

        <Col sm="8">
          <Form.Group className="mb-2" controlId="formPlaintext">
            <Form.Label column sm="5">
              Complemento
            </Form.Label>
            <div>
              <Form.Control type="text" {...register('address_complements')} />
              {errors.address_complements?.message && <div className="text-danger">{errors.address_complements?.message}</div>}
            </div>
          </Form.Group>
        </Col>
        <Col sm="4">
          <Form.Group className="mb-2" controlId="formPlaintextText">
            <Form.Label className="mt-2">
              Número
            </Form.Label>
            <div>
              <Form.Control type="text" {...register('address_number')} />
              {errors.address_number?.message && <div className="text-danger">{errors.address_number?.message}</div>}
            </div>
          </Form.Group>
        </Col>

        <Col sm="12">
          <Form.Group className="mb-2" controlId="formPlaintext">
            <Form.Label column sm="5">
              Bairro
            </Form.Label>
            <div>
              <Form.Control type="text"  {...register('address_neighbour')} />
              {errors.address_neighbour?.message && <div className="text-danger">{errors.address_neighbour?.message}</div>}
            </div>
          </Form.Group>
        </Col>

        <Col sm="12">
          <Form.Group className="mb-2" controlId="formPlaintext">
            <Form.Label column sm="5">
              Estado
            </Form.Label>
            <Form.Select placeholder="Estado" disabled aria-label="UF" {...register('state')}>
              <option defaultValue={''}>Estado</option>
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceará</option>
              <option value="DF">Distrito Federal</option>
              <option value="ES">Espírito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MT">Mato Grosso</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Pará</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO">Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
              <option value="EX">Estrangeiro</option>
            </Form.Select>
            {errors.state?.message && <div className="text-danger">{errors.state?.message}</div>}
          </Form.Group>
        </Col>

        <Col sm="12">
          <Form.Group className="mb-2" controlId="formPlaintext">
            <Form.Label column sm="5">
              Cidade
            </Form.Label>
            <div>
              <Form.Control type="text"  {...register('address_city')} />
              {errors.address_city?.message && <div className="text-danger">{errors.address_city?.message}</div>}
            </div>
          </Form.Group>
        </Col>

        <Col sm="12">
          <Form.Group className="mb-2" controlId="formPlaintext">
            <Form.Label column sm="5">
              Pais
            </Form.Label>
            <div>
              <Form.Control type="text" {...register('country')} />
              {errors.country?.message && <div className="text-danger">{errors.country?.message}</div>}
            </div>
          </Form.Group>
        </Col>


      <Row>
        <Col sm="6">
        <Form.Group className="mb-2" controlId="formPlaintext" hidden={true}>
          <Form.Label column sm="5">
              Latitude
            </Form.Label>
        
          <div >
              <Form.Control type="text"  {...register('latitude')} />
            </div>
          </Form.Group>
        </Col>

        <Col sm="6">
        <Form.Group className="mb-2" controlId="formPlaintext" hidden={true}>
          <Form.Label column sm="5">
            Longitude
          </Form.Label>

            <div >
              <Form.Control type="text" {...register('longitude')}/>
            </div>
          </Form.Group>
        </Col>
      </Row>

        <ButtonGroup className="col-12 mt-3 mb-2">
          <Button onClick={props?.back} className="btn btn-light btn-large" type="button">Voltar</Button>
          <Button className="btn btn-primary btn-large" type="submit">Salvar</Button>
        </ButtonGroup>
      </Row>
    </Form>
  );
}
const mapStateToProps = (state, props) => {
  const { address_city, address_neighbour, uf, address, country, latitude, longitude } = state.Provider;
  return {
    ...props,
    address_city,
    address_neighbour, 
    address, 
    country, 
    uf,
    latitude,
    longitude
  };
};

export default withTranslation()(withRouter(connect(mapStateToProps, { getPostalCode })(Index)));